import { FormattedMessage } from 'react-intl';
import { Box, Flex, Link, Text } from '@mollie/ui-react';

import { layoutMessages } from '../messages';
import './PageLayout.css';

interface PageLayoutProps {
  children: React.ReactNode;
}

export function PageLayout({ children }: PageLayoutProps) {
  return (
    <Box className="pc-page">
      <Box className="pc-header">
        <Box className="pc-header-inner">
          {/* eslint-disable-next-line @calm/react-intl/missing-formatted-message -- brand wordmark, never translated */}
          <Text className="pc-wordmark">mollie</Text>
        </Box>
      </Box>

      <Box className="pc-main">{children}</Box>

      <Box className="pc-footer">
        <Flex
          className="pc-footer-inner"
          justifyContent="center"
          alignItems="center"
          gap="space-200"
        >
          <Link href="https://www.mollie.com" className="pc-footer-link">
            <FormattedMessage {...layoutMessages.backToMollie} />
          </Link>
          <Text className="pc-footer-dot">·</Text>
          <Link href="https://help.mollie.com" className="pc-footer-link">
            <FormattedMessage {...layoutMessages.needHelp} />
          </Link>
        </Flex>
      </Box>
    </Box>
  );
}
